import { Injectable } from '@angular/core';
import { URLS } from '../shared/url';
import { BaseHttpService } from './base-http.service';
import { CompanyGridViewModel, CompanyViewModel } from '../models/generated-view-models';
import { Observable } from 'rxjs';
import { ResponseTypeEnum } from '../models/enums';


@Injectable({
    providedIn: 'root'
})
export class CompanyService {

    constructor(private http: BaseHttpService) { }

    public getCompanyList = (): Observable<CompanyGridViewModel[]> => {
        return this.http.Get(URLS.getCompanyList);
    }

    public getCompany = (id: number): Observable<CompanyViewModel> => {
        return this.http.Get(`${URLS.getCompany}/${id}`);
    }

    public saveCompany = (company: CompanyViewModel): Observable<boolean> => {
        return this.http.Post(URLS.saveCompany, company, ResponseTypeEnum.Success);
    }

    public deleteCompany = (companyId: number): Observable<boolean> => {
        return this.http.Delete(`${URLS.deleteCompany}/${companyId}`, ResponseTypeEnum.Success);
    }
}